

export default {
  labels: ["Jan","Feb","Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep"],
  datasets: [
    {
      label: "Web",
      color: "info",
      data: [50, 410, 320, 220, 280, 250, 400, 220, 500],
    },
    {
      label: "iOS",
      color: "dark",
      data: [125, 95, 140, 240, 290, 290, 340, 230, 400],
    },
    {
      label: "Android",
      color: "secondary",
      data: [30, 90, 40, 140, 290, 430, 340, 260, 380],
    },
  ],
};
